import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { State, getSelectedExhibitionId, getSelfRegistration, isLoggedInAsAdmin } from '@app/app.reducer';
import { CookiesPopupComponent } from '@app/cookies-popup/cookies-popup.component';
import { Store, select } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { getTranslationList } from '@store/translation/translation.selectors';
import { Subscription, combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-bottom-sticky',
  templateUrl: './bottom-sticky.component.html',
  styleUrls: ['./bottom-sticky.component.scss'],
  standalone: true,
  imports: [NgIf, CookiesPopupComponent]
})
export class BottomStickyComponent implements OnInit, OnDestroy {
  textWithLink = '';
  isCookiePopupEnabled = false;
  private isLoggedInAsAdmin = false;
  private checkCookiePopupStatus = true;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private store: Store<State>,
    private translateService: TranslateService
  ) {
    this.subscriptions.add(
      combineLatest([
        this.store.pipe(select(isLoggedInAsAdmin)),
        this.store.pipe(select(getSelfRegistration))
      ]).subscribe(([isLoggedInAsAdmin, isSelfRegistrationEnabled]) => {
        this.checkCookiePopupStatus = !isLoggedInAsAdmin && !isSelfRegistrationEnabled;
        this.isLoggedInAsAdmin = isLoggedInAsAdmin;
      })
    );
  }

  ngOnInit() {
    if (this.checkCookiePopupStatus) {
      this.subscriptions.add(
        combineLatest([
          this.store.pipe(select(isLoggedInAsAdmin)),
          this.store.pipe(select(getSelectedExhibitionId))
        ]).subscribe(() => {
          this.isCookiePopupEnabled = false;
        })
      );

      this.subscriptions.add(
        this.store
          .pipe(select(getTranslationList))
          .pipe(filter((translations) => !!translations))
          .subscribe((translations) => {
            if (!this.isLoggedInAsAdmin) {
              let cookiePopupText = translations['cookies.popup.text'];

              if (!cookiePopupText) {
                this.translateService.get('cookies.popup.text').subscribe((defaultCookiePopupText) => {
                  cookiePopupText = defaultCookiePopupText;
                });
              }

              this.isCookiePopupEnabled = cookiePopupText ? !cookiePopupText.startsWith('-notshown-') : false;

              if (this.isCookiePopupEnabled) {
                const linkTextOnly = cookiePopupText.match(/<.*?>/);

                if (linkTextOnly) {
                  const link = `<a href="#" target="_blank">${linkTextOnly[0].slice(1, -1)}</a>`;
                  this.textWithLink = cookiePopupText.replace(linkTextOnly[0], link);
                } else {
                  this.textWithLink = cookiePopupText;
                }
              }
            }
          })
      );
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
